import _ from 'lodash'

// We usually want to use `floor` instead of `round` so that 99.9% doesn't show up as 100% (important when displaying progress)
export const formatPercentage = (fraction: number | undefined, decimals = 0): string =>
  fraction !== undefined ? `${_.floor(fraction * 100, decimals)}%` : '-'
